import { i18n } from '@/lang/index.js'

const wordsMap = {
  coins: () => {
    return i18n.t('lang.BaseModule.k013')
  },
}

export default wordsMap
